import { Outlet } from 'react-router-dom';

import { ErrorBoundary } from '~/b4b/components/error-boundary/ErrorBoundary';
import ScrollToTopOnPathChange from '~/b4b/components/ScrollToTopOnPathChange';

export const Root = () => (
  <ErrorBoundary name="root" fallbackType="full">
    <ScrollToTopOnPathChange />
    <Outlet />
  </ErrorBoundary>
);
